import { ButtonProps } from "@origin-digital/ods-core";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useActionSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const changeSupplyButtonProps: ButtonProps = React.useMemo(() => {
    return {
      onClick: () => {
        navigate("/change-request", {
          state: {
            backUrl: location.pathname + location.search,
          },
        });
      },
      "data-id": "actionSection.changeSupplyButton",
    };
  }, [navigate, location.pathname, location.search]);

  const removeSupplyButtonProps: ButtonProps = React.useMemo(() => {
    return {
      onClick: () => {
        navigate("/remove-supply", {
          state: {
            backUrl: location.pathname + location.search,
          },
        });
      },
      "data-id": "actionSection.removeSupplyButton",
    };
  }, [navigate, location.pathname, location.search]);

  return {
    changeSupplyButtonProps,
    removeSupplyButtonProps,
  };
};
